export class PeriodoContratoSummaryDto{
  public periodo!:number
  public descuento!:number
  public incremento!:number
  public importeAlquiler!:number
  public valorAjuste!:number
  public fechaAjuste!:string
  public idIndiceAjusteContrato?:number
}
